import { useState, useRef } from 'react'
import { theme } from 'styles/theme/hav-theme'
import { useAuth } from 'commons/customHooks/useAuth'
import { useUserName } from 'commons/customHooks/useAuth'

import MenuItem from '@mui/material/MenuItem'
import ExitToApp from '@mui/icons-material/ExitToApp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import * as S from './styles'

interface ProfileMenuProps {
  onLogout: () => void
}

export const ProfileMenu: React.FC<ProfileMenuProps> = ({ onLogout }) => {
  let userName = 'Usuário'
  const isAuthenticated = useAuth()
  if (isAuthenticated) {
    userName = useUserName()
  }

  const containerRef = useRef<HTMLDivElement>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div ref={containerRef}>
      <S.StyledButton
        id="profile-menu-button"
        aria-controls={open ? 'profile-menu-button' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {userName}
      </S.StyledButton>
      <S.StyledMenu
        id="profile-menu"
        MenuListProps={{
          'aria-labelledby': 'profile-menu-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        minwidth={containerRef.current?.clientWidth}
      >
        <MenuItem onClick={onLogout} sx={{ color: theme.colors.support.red }}>
          <ExitToApp />
          Sair
        </MenuItem>
      </S.StyledMenu>
    </div>
  )
}
